import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OccMatrixComponent } from '../occ_matrix/occ_matrix.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OccMatrixService } from '../occ_matrix.service';
import { OccMatrix } from '../occ_matrix';

@Component({
    selector: 'app-occMatrix-list',
    templateUrl: './occ_matrix-list.component.html',
    styleUrls: ['./occ_matrix-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
		:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
			position: -webkit-sticky;
			position: sticky;
			top: 0px;

			white-space: normal !important;   /* allow wrapping */
			word-break: break-word;
			vertical-align: middle;
			text-align: center;
		}

		:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
			text-align: center;
			white-space: nowrap; /* keep values in one line */
		}

		@media screen and (max-width: 64em) {
			:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
				top: 99px;
			}
		}
	`],
    standalone: false
})
export class OccMatrixListComponent implements OnInit {
	constructor(
		private occMatrixService: OccMatrixService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = occMatrixService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	occMatrixs: any;
	occMatrix: OccMatrix;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'occMatrixId', header: 'Id', width: '80px' },
		{ field: 'occMapName', header: 'Occ Map', width: '120px' },
		{ field: 'daysToArrivalTo', header: 'Days to Arrival To', width: '70px' },
		{ field: 'daysToArrivalFrom', header: 'Days to Arrival From', width: '70px' },
		{ field: 'expNominalOccToDatePct', header: 'Exp Nominal Occ To Date Pct', width: '80px' },
		{ field: 'seasonCode', header: 'Season Code', width: '80px' },
		{ field: 'minStayExpectedNTS', header: 'Min Stay Exp NTS', width: '80px' },
		{ field: 'shortTermGapMultiplierPCT', header: 'ST Gap Multiplier %', width: '80px' },
		{ field: 'shortTermGapMinNumNightsRevNTS', header: 'ST Gap Min Rev NTS', width: '80px' },
		{ field: 'longTermGapMultiplierPCT', header: 'LT Gap Multiplier %', width: '80px' },
		{ field: 'longTermGapEmptyMultiplierPCT', header: 'LT Gap Empty Multiplier %', width: '90px' },
		{ field: 'connectingFrontOrBackMultiplierPCT', header: 'Connecting Front Or Back %', width: '95px' },
		{ field: 'connectingFrontAndBackMultiplierPCT', header: 'Connecting Front And Back %', width: '95px' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.occMatrixId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-occMatrix-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.occMatrixService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.occMatrixs = res.data.occMatrixs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.occMatrixs = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(occMatrix: OccMatrix) {
		try {
			this.formLoading = true;
			this.occMatrixService.update(occMatrix)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.occMatrixs.map((occMatrix, i) => {
							if (occMatrix.occMatrixId === res.data.occMatrix.occMatrixId) {
								this.occMatrixs[i] = res.data.occMatrix;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(occMatrix: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(occMatrix));

			this.formLoading = true;
			this.occMatrixService.delete(occMatrix.occMatrixId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.occMatrixs.splice(this.occMatrixs.indexOf(occMatrix), 1);
						this.recordTotal = this.occMatrixs.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OccMatrix ' + occMatrix.occMatrixId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OccMatrix ' + occMatrix.occMatrixId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OccMatrix'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OccMatrixComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOccMatrixCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(occMatrix: OccMatrix) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			occMatrix: occMatrix,
			title: 'Edit OccMatrix'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OccMatrixComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOccMatrixCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOccMatrixCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOccMatrixCB(occMatrix: OccMatrix) {
		console.log('Adding OccMatrix: ' + JSON.stringify(occMatrix));
		// if we don't have a occMatrixs array yet...
		if (!this.occMatrixs) {
			this.occMatrixs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.occMatrixs.unshift(occMatrix);

		// no idea what this is but it is required to update the array
		this.occMatrixs = [...this.occMatrixs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccMatrix ' + occMatrix.occMatrixId + ' Added', life: 3000 });
	}

	updateOccMatrixCB(occMatrix: OccMatrix) {
		console.log('Updating OccMatrix: ' + JSON.stringify(occMatrix));
		let itemIndex = this.occMatrixs.findIndex((item: any) => item.occMatrixId === occMatrix.occMatrixId);
		this.occMatrixs[itemIndex] = occMatrix;

		// no idea what this is but it is required to update the array
		this.occMatrixs = [...this.occMatrixs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccMatrix ' + occMatrix.occMatrixId + ' Updated', life: 3000 });
	}

	deleteOccMatrixCB(occMatrix: OccMatrix) {
		console.log('Removing OccMatrix: ' + occMatrix);
		this.occMatrixs.splice(this.occMatrixs.indexOf(occMatrix), 1);
		this.recordTotal = this.occMatrixs.length;

		// no idea what this is but it is required to update the array
		this.occMatrixs = [...this.occMatrixs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccMatrix ' + occMatrix.occMatrixId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.occMatrixs ? this.first === (this.occMatrixs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.occMatrixs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(occMatrix: any) {
		if (occMatrix?.status) {
			const status = this.statuses.find((e: any) => e.value == occMatrix.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
